import * as easing from '_pixiSrc/animation/easing';
import Tween from '_pixiSrc/animation/Tween';
import Static from '../libraries/Static';
import GameData from '../ui/GameData';

import {
    GAME_DATA_KEY,
} from '../Constants';

let data = {}; // object values and options for the display of text

const links = {}; // object with links to all the elements that contain text

const obj = {}; // fake object, is used simply to create a tween

let BALANCE = -1;

/**
 * @class DynamicData
 * @memberOf module:ui
 * @classdesc DynamicData class store all text elements with data
 * change text data automatic on input data change
 */
class DynamicData {
    /**
   * @name init
   * @description set initial game data
   */
    static init() {
        data = {
            bet: {
                value: 10,
                easing: null,
                looped: true,
                time: 0,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('bet'),
                prefix: '',
                suffix: '',
            },
            lines: {
                value: 1,
                max: 10,
                min: 1,
                looped: true,
                easing: null,
                time: 0,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('lines'),
                prefix: '',
                suffix: '',
            },
            totalBet: {
                value: 10,
                easing: easing.cubic.easeInOut,
                time: 1000,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('totalBet'),
                prefix: '',
                suffix: '',
            },
            coins: {
                value: GameData.getProperty('coins'),
                max: Infinity,
                min: 0,
                easing: easing.linear.easeInOut,
                time: 0,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('coins'),
                prefix: '',
                suffix: '',
            },
            lastWin: {
                value: 0,
                easing: easing.linear.easeInOut,
                time: 0,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('lastWin'),
                prefix: '',
                suffix: '',
                isHidingAtZero: false, // flag that allows you to hide text if the value is zero
            },
            lastExpandingWin: {
                value: 0,
                easing: easing.linear.easeInOut,
                time: 0,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('lastExpandingWin'),
                prefix: '',
                suffix: '',
                isHidingAtZero: false, // flag that allows you to hide text if the value is zero
            },
            FGWin: {
                value: 0,
                easing: easing.linear.easeInOut,
                min: 0,
                time: 1000,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('FGWin'),
                prefix: '',
                suffix: '',
            },
            FGCounterMax: {
                value: 10,
                easing: easing.linear.easeInOut,
                min: 10,
                time: 1000,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('FGCounter'),
                prefix: '',
                suffix: '',
            },
            FGCounter: {
                value: 0,
                easing: null,
                min: 0,
                time: 0,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('FGCounter'),
                prefix: 'FREE GAME ',
                suffix: ' OF ',
            },
            GGCollected: {
                value: 0,
                easing: easing.linear.easeInOut,
                min: 0,
                time: 1000,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('GGCollected'),
                prefix: '',
                suffix: '',
            },
            GGWin: {
                value: 0,
                easing: easing.linear.easeInOut,
                min: 0,
                time: 0,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('GGWin'),
                prefix: '',
                suffix: '',
            },
            GSCounterMax: {
                value: 0,
                easing: easing.linear.easeInOut,
                min: 10,
                time: 1000,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('GSCounterMax'),
                prefix: '',
                suffix: '',
            },
            GSCounter: {
                value: 0,
                easing: null,
                min: 0,
                time: 0,
                font: 'font_yellow3',
                isInGameData: !!GameData.getProperty('GSCounter'),
                prefix: '',
                suffix: '',
            },
            wins: {
                winCoins: 0,
                winLines: [],
                winLinesCount: 0,
            },
            freeSpinData: {
                currentFreeSpin: 0,
                freeSpins: 0,
                winAmount: 0,
                isFreeSpinAwarded: false,
            },
            ladderWin: {
                value: 0,
            },
            ladderAmount: {
                value: 0,
            },
            collected: {
                value: 0,
            },
            specialSpinData: {
                freeSpins: 0,
                currentFreeSpin: 0,
                isSpinPurchase: false,
            },
        };
    }

    /**
   * @name write
   * @param parent
   * @param key
   * @param font
   * @param x
   * @param y
   * @param options
   * @param fitScale
   * @description method of write text to an element
   */
    static write(parent, key, font, x, y, options = {}, callback, fitScale) {
        const text = Static.writeText(parent, data[key].prefix + data[key].value + data[key].suffix, font || data[key].font, x, y, options);

        if (data[key].isHidingAtZero) {
            text.visible = (data[key].value !== 0);
        }

        if (!links[key]) {
            links[key] = [];
        }
        links[key].push(text);

        if (callback) {
            if (!data[key].callbacks) {
                data[key].callbacks = [];
            }
            data[key].callbacks.push(callback);
        }

        if (fitScale) {
            text.fitScale = fitScale;
            text.setScaleToFitWidth(fitScale.width, fitScale.min, fitScale.max);
        }

        if (callback) {
            setTimeout(callback, 0);
        }

        return text;
    }

    /**
   * @name writeNativeText
   * @param {DisplyObject} parent on which to write text
   * @param {String} key which key to fecth writing data
   * @param {String} font which font style to use
   * @param {Number} x
   * @param {Number} y
   * @param {Object} options other options
   * @param {Object} fitScale scale to width options of Static method
   * @description method of write text to an element using Pixi native text
   */
    static writeNativeText(parent, key, font, x, y, options = {}, callback, fitScale = null) {
        const text = Static.writeNativeText(parent, data[key].prefix + data[key].value + data[key].suffix, font || data[key].font, x, y, options);

        if (data[key].isHidingAtZero) {
            text.visible = (data[key].value !== 0);
        }

        if (!links[key]) {
            links[key] = [];
        }
        links[key].push(text);

        if (callback) {
            if (!data[key].callbacks) {
                data[key].callbacks = [];
            }
            data[key].callbacks.push(callback);
        }

        if (fitScale) {
            text.fitScale = fitScale;
            Static.setScaleToFitWidthNativeText(text, fitScale.width, fitScale.minScale, fitScale.maxScale);
        }
        if (callback) {
            setTimeout(callback, 0);
        }
        return text;
    }

    /**
   * @name _refreshValue
   * @param newValue
   * @param key
   * @description update values on all elements
   */
    static _refreshValue(key, newValue) {
        if (Array.isArray(links[key])) {
            links[key].forEach((e) => {
                const text = [];
                (function write(string) {
                    text.unshift(string.pop());
                    text.unshift(string.pop());
                    text.unshift(string.pop());
                    text.unshift(' ');
                    if (string.length) {
                        write(string);
                    }
                }((`${newValue}`).split('')));
                if (typeof e.write === 'function') {
                    e.write(text.join('').trim());
                } else {
                    e.scale.set(1);
                    e.text = text.join('').trim();
                }
                if (e.fitScale) {
                    if (typeof e.setScaleToFitWidth === 'function') {
                        e.setScaleToFitWidth(e.fitScale.width, e.fitScale.min, e.fitScale.max);
                    } else {
                        Static.setScaleToFitWidthNativeText(e, e.fitScale.width, e.fitScale.minScale, e.fitScale.maxScale);
                    }
                }

                if (data[key].isHidingAtZero) {
                    e.visible = (data[key].value !== 0);
                }
                if (data[key].callbacks) {
                    data[key].callbacks.forEach(e => e());
                }
            });
        }
    }

    /**
   * @name getData
   * @param key
   * @description get Dynamic Data and return
   */
    static getData(key) {
        if (!data[key]) {
            console.error(`Error getting dynamic data: key ${key}`);
        }
        return data[key];
    }

    /**
   * @name setValue
   * @param key
   * @param newValue
   * @description set new value
   */
    static setValue(key, newValue) {
        if (!data[key]) {
            console.error(`Error setting dynamic data value: key ${key} not top`);
        }
        data[key].value = newValue;
        if (key === GAME_DATA_KEY.BET || key === GAME_DATA_KEY.LINES) {
            this.setValue(GAME_DATA_KEY.TOTALBET, this.getValue(GAME_DATA_KEY.BET) * this.getValue(GAME_DATA_KEY.LINES));
        }
        this._refreshValue(key, newValue);
        if (data[key].isInGameData) {
            GameData.setProperty(key, newValue);
        }
    }

    static removeTweens(key) {
        if (data[key].tweens) {
            for (let i = 0; i < data[key].tweens.length; i++) {
                const tween = data[key].tweens[i];
                tween.finish();
            }
            Tween.destroy(data[key].tweens);
            data[key].tweens = [];
        }
    }

    /**
   * @name getValue
   * @param key
   * @description get current value by key
   */
    static getValue(key) {
        if (!data[key]) {
            console.error(`Error getting dynamic data value: key ${key} not top`);
        }
        return data[key].value;
    }

    /**
   * @name addValue
   * @param key
   * @param addingValue
   * @param finishCallback
   * @param staticTime
   * @description add or subtract a value
   */
    static addValue(key, addingValue, finishCallback = null, staticTime = -1) {
        const baseTime = staticTime >= 0 ? staticTime : data[key].time;

        let newValue = this.getValue(key) + addingValue;

        let time = addingValue > 4000 ? baseTime * 2
            : addingValue > 1000 ? baseTime * 1.5
                : baseTime;

        time /= 2;

        // check that the value does not go beyond the boundary
        if (typeof data[key].min !== 'undefined' && newValue < data[key].min) {
            if (data[key].looped) {
                newValue = data[key].max;
            } else {
                newValue = data[key].min;
            }
        }
        if (typeof data[key].max !== 'undefined' && newValue > data[key].max) {
            if (data[key].looped) {
                newValue = data[key].min;
            } else {
                newValue = data[key].max;
            }
        }

        if (!obj[key]) {
            obj[key] = 0;
        }
        const tween = new Tween(obj, key, data[key].value, newValue, time, data[key].easing).play();

        tween.on('change', (e) => {
            this._refreshValue(key, Math.floor(e.value));
        });

        tween.on('finish', (e) => {
            this._refreshValue(key, this.getValue(key));
            if (data[key].tweens) {
                const ix = data[key].tweens.indexOf(e.target);
                data[key].tweens.splice(ix, 1);
            }

            if (finishCallback) {
                finishCallback();
            }
        });

        data[key].value = newValue;
        if (data[key].isInGameData) {
            GameData.setProperty(key, newValue);
        }

        if (!data[key].tweens) {
            data[key].tweens = [];
        }
        data[key].tweens.push(tween);

        // a special case when you change lines or stakes, change value of total bet
        if (key === GAME_DATA_KEY.BET || key === GAME_DATA_KEY.LINES) {
            this.addValue(GAME_DATA_KEY.TOTALBET, this.getValue(GAME_DATA_KEY.BET) * this.getValue(GAME_DATA_KEY.LINES) - this.getValue(GAME_DATA_KEY.TOTALBET));
        }

        return tween;
    }

    /**
 * @name setCurrentBalance
 * @param val
 * @description set current balance
 */
    static setCurrentBalance(val) {
        BALANCE = val;
    }

    /**
   * @name getCurrentBalance
   * @description get current balance
   */
    static getCurrentBalance() {
        return BALANCE;
    }

    /**
   * @name setData
   * @param key
   * @param wins
   * @description set dynamic data
   */
    static setData(key, wins) {
        data[key] = wins;
    }
}

export default DynamicData;
